import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=3df75cea&scoped=true&"
import script from "./MenuList.vue?vue&type=script&lang=js&"
export * from "./MenuList.vue?vue&type=script&lang=js&"
import style1 from "./MenuList.vue?vue&type=style&index=1&id=3df75cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df75cea",
  null
  
)

export default component.exports